import React from "react";
import T from "prop-types";
import {
  calculateValue,
  conversionUnit,
  conversionUnitAbbrev
} from "LIB/formatters/weight";

export default function ConvertedWeight({ unit, weight }) {
  return (
    <div>
      <label className="control-label" htmlFor="read_only_conversion">
        {conversionUnit(unit)}
      </label>
      <div className="input-group">
        <input
          name="read_only_conversion"
          className="form-control"
          type="text"
          value={weight ? calculateValue(unit, weight) : ""}
          disabled
          readOnly
        />
        <span className="input-group-addon">{conversionUnitAbbrev(unit)}</span>
      </div>
    </div>
  );
}

ConvertedWeight.propTypes = {
  weight: T.string,
  unit: T.string
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/ConvertedWeight.jsx